import React, { useState, useEffect  } from 'react'
import { Radio, Spin } from 'antd'
import PDFBadge from "components/icons/PDFBadge";
import DOCBadge from "components/icons/DOCBadge";
import DeleteIcon from "components/icons/Delete";
import PILBadge from "components/icons/PILBadge";
import Button from "components/Button";
import styled from "styled-components";
import SuccessMessage from "utils/SuccessMessage"
import moment from "moment";
import {
  StyledDrawer,
  FooterFlex,
} from '../DrawerStyle'
import {
  ResumeCard,
  ResumeLeft,
  ResumeFileName,
  ResumeDate,
  ResumeActions,
} from '../ResumeStyle'
import DownloadIcon from 'components/icons/DownArrowIcon'

const DrawerListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DefaultResumeDrawer = ({
  drawerStatus,
  setDrawerStatus,
  resumeFiles = [],
  pilResume = false,
  defaultId = null,
  onSetDefault,
  onDownload,
  getStudentResumeData,
  studentId,
  onDeleteResume,
  studentUpdateAt,
  getPendingData,        
  pendingData,
}) => {
  const [selectedId, setSelectedId] = useState(defaultId)
  const [localFiles, setLocalFiles] = useState([]);
  const [loadingResumes, setLoadingResumes] = useState(false);
  
  const handleClose = () => {
    setDrawerStatus(false)
  }

  useEffect(() => {
    if (drawerStatus) {
      setLocalFiles(resumeFiles);
      setSelectedId(defaultId);
    }
  }, [drawerStatus, resumeFiles, defaultId])

  const handleConfirm = () => {
    if (selectedId && onSetDefault) {
      onSetDefault(selectedId)
    }
    setDrawerStatus(false)
  }

  const downloadURI = async (file) => {
    try {
      const response = await fetch(file.url)
      if (!response.ok) {
        throw new Error('Failed to download file')
      }
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = file.name
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  const renderUserFiles = () =>
    localFiles.map((file) => {
      const isSelected = selectedId === file.id;
      const isPdf = file.fileFormat === "pdf" ;
      const isDefault = file.isDefault;
      if (file.type !== "SYSTEM") {
        return (
          <ResumeCard
            key={file.id}
            style={{
              cursor: file.isPending ? "not-allowed" : "pointer",
              background: isDefault ? "#DAECFF" : "#FFFFFF",
              borderColor:
                isSelected && !isDefault
                  ? "#3249D7"
                  : "#E6E7EA",
            }}
            onClick={() => {
              if (!file.isPending) {
                setSelectedId(file.id);
              }
            }}
          >
            <ResumeLeft>
              {isPdf ? <PDFBadge /> : <DOCBadge />}
              <div>
                <ResumeFileName>{file.name}</ResumeFileName>
                <ResumeDate>Uploaded on {file.uploadedOn}</ResumeDate>
              </div>
            </ResumeLeft>

            <ResumeActions>
              {file.isDefault && (
                <div
                  style={{
                    width: 67,
                    height: 26,
                    borderRadius: 5,
                    background: "#F2F7FF",
                    border: "1px solid #DAE6FF",
                    color: "#3A66FF",
                    fontSize: 12,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 10,
                  }}
                >
                  Default
                </div>
              )}
              {file.isPending && (
                <div
                  style={{
                    padding: "4px 10px",
                    borderRadius: 5,
                    background: "#FFF7E6",
                    border: "1px solid #FFD591",
                    color: "#D46B08",
                    fontSize: 12,
                    fontWeight: 500,
                    marginRight: 10,
                  }}
                >
                  Pending approval
                </div>
              )}
              <span
                onClick={async (e) => {
                  e.stopPropagation();
                  setLocalFiles(prev => prev.filter(f => f.id !== file.id));
                  if (selectedId === file.id) {
                    setSelectedId(null);
                  }
                  setLoadingResumes(true);
                  await onDeleteResume(file.id);
                  setLoadingResumes(false);
                }}
              >
                <DeleteIcon />
              </span>
              <Radio
                disabled={file.isPending}
                checked={isSelected}
                onChange={() => setSelectedId(file.id)}
              />
            </ResumeActions>
          </ResumeCard>
        );
      } else {
        return (
          <ResumeCard
            key={file.id}
            style={{
              cursor: file.isPending ? "not-allowed" : "pointer",
              background: isDefault ? "#DAECFF" : "#FFFFFF",
              borderColor:
                isSelected && !isDefault
                  ? "#3249D7"
                  : "#E6E7EA",
            }}
            onClick={() => {
              if (!file.isPending) {
                setSelectedId(file.id);
              }
            }}
          >
            <ResumeLeft>
              <PILBadge />
              <div>
                <ResumeFileName>PIL Resume</ResumeFileName>
                <ResumeDate>Updated on {moment(studentUpdateAt).format("DD/MM/YYYY")}</ResumeDate>
              </div>
            </ResumeLeft>

            <ResumeActions>
              {file.isDefault && (
                <div
                  style={{
                    width: 67,
                    height: 26,
                    borderRadius: 5,
                    background: "#F2F7FF",
                    border: "1px solid #DAE6FF",
                    color: "#3A66FF",
                    fontSize: 12,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 10,
                  }}
                >
                  Default
                </div>
              )}
              <div
                style={{
                  background: "#F0F4FF",
                  padding: "4px 10px",
                  borderRadius: "6px",
                  fontSize: "11px",
                  fontWeight: 600,
                  color: "#3249D7",
                  letterSpacing: "0.3px",
                }}
              >
                System Generated
              </div>
              <Radio
                disabled={file.isPending}
                checked={isSelected}
                onChange={() => setSelectedId(file.id)}
              />
            </ResumeActions>
          </ResumeCard>
        );
      }
    });

  const content = () => (
    <DrawerListWrapper>
      {loadingResumes ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Spin size="large" />
        </div>
      ) : (
        renderUserFiles()
      )}
    </DrawerListWrapper>
  )

  const footer = () => (
    <FooterFlex right>
      <Button.Secondary text="Cancel" onClick={handleClose} />
      <Button.Primary
        text="Set Default"
        disabled={!selectedId}
        onClick={handleConfirm}
      />
    </FooterFlex>
  )

  return (
    <StyledDrawer
      width="720px"
      title="Set Default Resume"
      placement="right"
      closable
      onClose={handleClose}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  )
}

export default DefaultResumeDrawer
